import { render, staticRenderFns } from "./ans.vue?vue&type=template&id=0b37f4a2&scoped=true"
import script from "./ans.vue?vue&type=script&lang=js"
export * from "./ans.vue?vue&type=script&lang=js"
import style0 from "./ans.vue?vue&type=style&index=0&id=0b37f4a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37f4a2",
  null
  
)

export default component.exports